module.exports = window["nab"]["data"];